<template>
  <v-flex xs12>
    <h2 class="nx-heading--level-1">{{ title }}</h2>
    <v-radio-group class="filters-radio-group" row v-model="filterValue">
      <v-radio v-for="type in availableBoardFilters"
               :key="type"
               :label="$t(`message.permissions.filters.${type}`)"
               :value="type"></v-radio>
    </v-radio-group>
    <div v-if="filterValue === 'id'">
      <nx-board-selector :value="boardId"
                         @input="handleInput"
                         :disableBoardCreation="true"
                         :label="$t('message.permissions.filters.boardSelector')">
      </nx-board-selector>
    </div>
  </v-flex>
</template>

<script>
import BoardSelector from '@/modules/board/selector/Selector';

export default {
  name: 'nx-authorization-permissions-wizard-board-filter',
  components: {
    [BoardSelector.name]: BoardSelector,
  },
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      filterValue: null,
      board: null,
    };
  },
  computed: {
    title() {
      return this.$t('message.permissions.wizard.steps.filter', {
        resource: this.$t('message.permissions.resources.boards'),
      });
    },
    availableBoardFilters() {
      return ['all', 'id'];
    },
    filters() {
      const filters = {};

      if (this.filterValue === 'all') {
        filters.boardType = this.filterValue;
      }

      if (this.filterValue === 'id'
        && this.board) {
        filters.board = this.board;
        filters.boardId = this.board.id;
      }

      return filters;
    },
    boardId() {
      if (!this.board) {
        return null;
      }
      return this.board.id;
    },
  },
  methods: {
    handleInput(boardId, board) {
      this.board = board;
    },
  },
  watch: {
    filters(value) {
      this.$emit('input', value);
    },
  },
};
</script>
